import { defineComponent as _defineComponent } from 'vue'
import { SalesBotStepKey, TripTypeKey } from "@/utils/enum"
import { computed, onMounted } from "vue"
import CURadioButton from "@/components/CURadioButton.vue"
import { useDisplay } from '@/composables/useDisplay'
import { useGoogleAnalytics, Event } from "@/composables/useGoogleAnalytics"
import { useAuth0 } from "@/composables/useAuth0"
import oneWayIcon from "@/assets/images/one-way.svg"
import roundTripIcon from "@/assets/images/round-trip.svg"
import largeEventIcon from "@/assets/images/large-events.svg"
import { useSalesBotStore } from "@/store/modules/salesBot"
import auth from "@/store/modules/auth";

interface TripType {
  key: TripTypeKey
  label: string
  icon: any
  description: string
}

// TODO: This type will be added to support corporate shuttles as part of CUWEB-1081.
// {
//   key: TripTypeKey.Shuttle,
//   label: "Corporate Shuttle",
//   icon: corporateShuttleIcon,
//   description: "Daily commutes and business travel for employees.",
// },

export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripTypeV2',
  setup(__props) {

const tripTypes: TripType[] = [
  {
    key: TripTypeKey.OneWay,
    label: "One Way",
    icon: oneWayIcon,
    description: "A one way trip is pretty self-explanatory.",
  },
  {
    key: TripTypeKey.RoundTrip,
    label: "Round Trip",
    icon: roundTripIcon,
    description: "A round trip always brings you back home.",
  },
  {
    key: TripTypeKey.LargeEvent,
    label: "Large Event",
    icon: largeEventIcon,
    description: "A large event requires six or more vehicles.",
  },
]

const salesBotStore = useSalesBotStore()
const { xs, smAndUp } = useDisplay()
const startingTripTypeKey = salesBotStore.tripTypeKey

const tripTypeStep = salesBotStore.getStepByKey(SalesBotStepKey.TripType)

const selectedTripType = computed<TripType | null>(() => {
  const selectedTripType = tripTypes.find(
      (tripType) => salesBotStore.tripTypeKey === tripType.key
  )
  return selectedTripType || null
})

function isTripTypeSelected(key: TripTypeKey): boolean {
  if (!selectedTripType) {
    return false
  }
  return selectedTripType.value.key === key
}

function selectTripType(key: TripTypeKey): void {
  salesBotStore.setTripTypeKey(key)
}

const isValid = () => Object.values(TripTypeKey).includes(selectedTripType.value.key)

function onClickContinue(): void {
  if (!isValid()) {
    return
  }
  salesBotStore.setStepValid(SalesBotStepKey.TripType, true)
  salesBotStore.applyDefaultStopLogic(startingTripTypeKey, selectedTripType.value.key)

  trackEvent(Event.TripType);
  tripTypeStep.next()
}

onMounted(() => {
  trackEvent(Event.ViewStart)
})

// GA4 TRACKING
const analytics = useGoogleAnalytics()
const auth0 = useAuth0()

function trackEvent(event: Event): void {
  const isLoggedIn = !!auth.isTokenSet && !!auth.userId
  const hasBookedBefore = auth?.customer?.convertedQuoteCount > 0

  analytics.trackEvent(event, {
    isAuth0: auth0.isInitialized,
    hasBookedBefore,
    isLoggedIn,
  })
}


return { __sfc: true,tripTypes, salesBotStore, xs, smAndUp, startingTripTypeKey, tripTypeStep, selectedTripType, isTripTypeSelected, selectTripType, isValid, onClickContinue, analytics, auth0, trackEvent, CURadioButton }
}

})